import type { Reducer } from 'redux';
import { Actions } from '@/redux/auth/actions';
import type { AuthState, AuthAction } from '@/redux/auth/types';

const refreshExpiresAt = window.localStorage.getItem('refreshExpiresAt');
const refreshToken = window.localStorage.getItem('refreshToken');

export const initialState = {
  accessExpiresAt: null,
  accessToken: null,
  refreshExpiresAt,
  refreshToken
} as AuthState;

export default ((state = initialState, action: AuthAction) => {
  switch (action.type) {
    case Actions.SetAuthData:
      return { ...state, ...action.data };

    case Actions.SetAuthDataFail:
      return { ...state, error: action.error };

    default:
      return state;
  }
}) as Reducer<AuthState, AuthAction>;
